import React from "react";
import { useTranslation } from "react-i18next";
import { ContractingState } from "features/contracting/enums/contractingState";

type Props = {
  state: ContractingState;
  textType: "customer" | "admin";
};

const ContractingStateLabel = ({ state, textType }: Props) => {
  const { t } = useTranslation(["contracting\\enums\\contractingState"]);

  switch (state) {
    case ContractingState.ColectingData:
      return (
        <span className="badge badge-pill badge-info small font-weight-normal mw-100 text-truncate">
          {t(`${state}.${textType}`)}
        </span>
      );
    case ContractingState.DocumentSentToSignOK:
      return (
        <span className="badge badge-pill badge-warning small font-weight-normal mw-100 text-truncate">
          {t(`${state}.${textType}`)}
        </span>
      );
    case ContractingState.SentToFlexiOK:
    case ContractingState.ContractingComplete:
      return (
        <span className="badge badge-pill badge-success small font-weight-normal mw-100 text-truncate">
          {t(`${state}.${textType}`)}
        </span>
      );
    case ContractingState.AdditingDataPrintFailed:
    case ContractingState.DocumentPrintFailed:
    case ContractingState.DocumentSentToSignFailed:
    case ContractingState.DocumentSignedFailed:
    case ContractingState.AdditingDataApiFailed:
    case ContractingState.SentToFlexiFailed:
    case ContractingState.ContractingFailed:
      return (
        <span className="badge badge-pill badge-danger small font-weight-normal mw-100 text-truncate">
          {t(`${state}.${textType}`)}
        </span>
      );
    case ContractingState.Cancelled:
      return(
        <span className="badge badge-pill small font-weight-normal mw-100 text-truncate" style={{ backgroundColor: "#8c8c8c", color: "#fff" }}>
          {t(`${state}.${textType}`)}
        </span>
      );
    default:
      return null;
  }
};

export default ContractingStateLabel;
